function checkTime(i) {
    if (i <= 10) {
        i = "0" + i;
    }
    return i;
}

function countdown(time, now = new Date().getTime()) {
    let result;
    time = time - 0;
    now = now - 0;
    let ts = (time- now) / 1000;//计算剩余的毫秒数
    let dd = parseInt(ts / 60 / 60 / 24, 10);//计算剩余的天数
    let hh = parseInt(ts / 60 / 60 % 24, 10);//计算剩余的小时数
    let mm = parseInt(ts / 60 % 60, 10);//计算剩余的分钟数
    let ss = parseInt(ts % 60, 10);//计算剩余的秒数
    dd = checkTime(dd);
    hh = checkTime(hh);
    mm = checkTime(mm);
    ss = checkTime(ss);
    if (ts > 0) {
        result = {dd:dd, hh:hh, mm:mm, ss:ss}
    } else if (ts < 0) {
        result = 'timeOver'
    }
    return result;
}

export default {
    countdown
}